import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Format an unknown caught value into a readable string.
 * Capacitor plugins often reject with plain objects ({}) instead of Error
 * instances, so JSON.stringify is the only way to surface useful detail.
 */
export function fmtErr(e: unknown): string {
  if (e instanceof Error) return e.stack ?? e.message;
  if (typeof e === "string") return e;
  return JSON.stringify(e);
}

/**
 * Returns true when a Capacitor-style rejection represents a user cancellation
 * rather than a real failure. Capacitor Share / Camera plugins reject with
 * `{ errorMessage: "..." }` containing cancel-related strings.
 */
export function isUserCancellation(e: unknown): boolean {
  if (e && typeof e === "object") {
    const msg =
      (e as any).errorMessage ?? (e as any).message ?? "";
    if (typeof msg === "string") {
      const lower = msg.toLowerCase();
      return (
        lower.includes("cancel") ||
        lower.includes("dismissed") ||
        lower.includes("abort")
      );
    }
  }
  return false;
}
